/* import __COLOCATED_TEMPLATE__ from './out-noise.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();